import { Component, Input,ElementRef,Output,EventEmitter  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBoolean, OrderDetailsNew } from '../../models/order.models';
import { MagnifierComponent } from '../magnifier/magnifier.component';
@Component({
  selector: 'app-abutment-emergence',
  standalone: true,
  imports: [CommonModule,MagnifierComponent],
  templateUrl: './abutment-emergence.component.html',
  styleUrl: './abutment-emergence.component.css'
})
export class AbutmentEmergenceComponent {
     @Input() orderDetailsNew!: OrderDetailsNew;
      @Input() showSlider: MyBoolean | undefined;
      @Input() readonly: boolean = false;
      @Input() anterior!: boolean;
      @Input() teeth!: number[];
      @Output() abutmentStep2Change = new EventEmitter<string>();
   @Input() abutmentSelectedTeeth: number[] = [];

  get isAbutmentNarrowSelected(): boolean {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) {
    return false;
  }

  return this.orderDetailsNew.toothData
    .filter(t => this.abutmentSelectedTeeth.includes(t.teeth))
    .some(t => t['abutmentStep1'] === 'Narrow healing space');
  }


  get isAbutmentWideSelected(): boolean {
  return this.orderDetailsNew.toothData
    .filter(t => this.abutmentSelectedTeeth.includes(t.teeth))
    .some(t => t['abutmentStep1'] === 'Wide healing space');
}

get isAbutmenthighlySelected(): boolean {
  return this.orderDetailsNew.toothData
    .filter(t => this.abutmentSelectedTeeth.includes(t.teeth))
    .some(t => t['abutmentStep1'] === 'Highly placed implant');
}
 onAabutmentStep2Selection(AbutmentStep2Option: string) {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return;

  // Apply selection to all selected teeth
  this.orderDetailsNew.toothData
    .filter(t => this.abutmentSelectedTeeth.includes(t.teeth))
    .forEach(t => t['abutmentStep2'] = AbutmentStep2Option);

  this.abutmentStep2Change.emit(AbutmentStep2Option);
}

shouldBeCheckedForTooth(step: string, value: string): boolean {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) return false;

  // Return true if **any selected tooth** has this value
  return this.orderDetailsNew.toothData
    .filter(t => this.abutmentSelectedTeeth.includes(t.teeth))
    .some(t => t[step] === value);
}

getFirstSelectedAbutmentStep(): string | null {
  if (!this.abutmentSelectedTeeth || this.abutmentSelectedTeeth.length === 0) {
    return null;
  }

  // Find the first selected tooth
  const firstToothId = this.abutmentSelectedTeeth[0];
  const toothData = this.orderDetailsNew.toothData.find(t => t.teeth === firstToothId);

  if (!toothData) {
    return null;
  }

  // Log the first step (abutmentStep1)
  return toothData['abutmentStep1'] || null;
}
}
